import React from "react";
import styled from "styled-components";
import BannerDesktop from "./BannerDesktop";
import DropdownLogout from "./DropdownLogout";
import { useTransaction } from "../hooks/useTransaction";

const Wrapper = styled.div`
  position: relative;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const DropdownWrap = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
`;

export default function DesktopPageHeader({ title, ...props }) {
  const { points, pointsLoader } = useTransaction();

  return (
    <Wrapper>
      <BannerDesktop
        {...props}
        title={title}
        points={points?.points || 0}
        labelPoints="Puntos"
        loaderPoints={pointsLoader}
      />
      <DropdownWrap>
        <DropdownLogout color="#ffffff" />
      </DropdownWrap>
    </Wrapper>
  );
}
